import React from 'react';
import './loading.css';

const Loading = () => {
    return (
        <div className="loading-spinner">
            <div className="bubble1"></div>
            <div className="bubble2"></div>
            <div className="bubble3"></div>
        </div>
    );
};

export default Loading;
